import React from 'react';

export const Exit = (props) => {
  // console.log('Add', props);
  return (
    <svg height={props.size} width={props.size} color={props.color} version="1.1" x="0px" y="0px" viewBox="0 0 80 80" enableBackground='new 0 0 80 80' xmlSpace="preserve">
      <polygon points="33.9,32.5 28.3,32.5 33.9,38.1 17,38.1 17,41.9 33.9,41.9 28.3,47.5 33.9,47.5 41.4,40 " />
      <path d="M63,13.1h-5.2L45,10v3.1H23.6v19.4h2V15.1H45v50H25.6V47.5h-2V67H45v3l12.8-3H63V13.1z M48.9,38.9V41  c0,0.4-0.3,0.7-0.7,0.8h-0.4c-0.4,0-0.8-0.3-0.8-0.7v-2.2c0-0.4,0.4-0.8,0.8-0.7h0.4C48.6,38.2,48.9,38.5,48.9,38.9z" />
    </svg>
  )
}


// <svg height={props.size} width={props.size} version="1.1" x="0px" y="0px" viewBox="0 0 104.5 100" enableBackground="new 0 0 104.5 100" xmlSpace="preserve">
//   <g>
//     <polygon points="32.235,24.046 32.235,15.958 22.132,15.958 22.132,34.148 3,53.279 10.143,60.423 19.724,50.842    19.724,90.046 83.229,90.046 83.229,50.842 92.809,60.423 99.953,53.279 51.479,4.802  " />
//   </g>
// </svg>



// WEBPACK FOOTER //
// ./client/src/img/exit.js